
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { ScheduledPickup } from '@/features/dashboard/types';
import SmallCalendar from '@/features/dashboard/components/widgets/scheduledPickups/SmallCalendar.vue';
import PickupItemDetails from '@/features/dashboard/components/widgets/scheduledPickups/PickupItemDetails.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component({
  components: {
    SmallCalendar,
    PickupItemDetails,
  },
})
export default class PickupItem extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) pickup!: ScheduledPickup;

  @Prop({ default: false }) today!: boolean;

  private showExpand = false;

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.pickup.carrierCode, this.pickup.selectedService || '');
  }
}
